(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
var snzRecProductsByHandle = {};

function snzFormatMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

function snzImageUrl(src) {
  if (!src) { return ""; }
  return src.indexOf("http") === 0 ? src : "https:" + src;
}

function snzOptionValue(variant, idx) {
  if (idx === 0) { return variant.option1; }
  if (idx === 1) { return variant.option2; }
  if (idx === 2) { return variant.option3; }
  return null;
}

function snzGetRecentlyViewedHandles() {
  try {
    var raw = localStorage.getItem("snoozies_recently_viewed");
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function snzBuildRecCardHTML(product) {
  var variants = product.variants || [];
  var optionDefs = product.options || [];
  var mainImg = snzImageUrl(product.featured_image);
  var safeTitle = (product.title || "").replace(/\"/g, "&quot;");

  var sizeIdx = -1;
  for (var i = 0; i < optionDefs.length; i++) {
    if (/size/i.test(optionDefs[i].name)) { sizeIdx = i; break; }
  }
  var colorIdx = -1;
  for (var j = 0; j < optionDefs.length; j++) {
    if (j !== sizeIdx) { colorIdx = j; break; }
  }

  var spacerHTML = '<div class="cart-rec-card__select-spacer" aria-hidden="true"></div>';
  var controlsHTML;

  if (variants.length <= 1 || optionDefs.length === 0) {
    var onlyVariant = variants[0];
    controlsHTML = '<div class="cart-rec-card__controls">' + spacerHTML + spacerHTML +
      '<button type="button" class="btn cart-rec-card__add-btn" data-variant-id="' + (onlyVariant ? onlyVariant.id : "") + '">Add To Cart</button>' +
      '</div>';
  } else if (colorIdx === -1) {
    var seenS = {};
    var optsS = "";
    variants.forEach(function(v) {
      var val = snzOptionValue(v, sizeIdx);
      if (v.available && val && !seenS[val]) { seenS[val] = true; optsS += '<option value="' + val.replace(/\"/g, "&quot;") + '">' + val + '</option>'; }
    });
    controlsHTML = '<div class="cart-rec-card__controls">' + spacerHTML +
      '<select class="cart-rec-card__select" data-role="size"><option value="">Pick a ' + optionDefs[sizeIdx].name + '</option>' + optsS + '</select>' +
      '<button type="button" class="btn cart-rec-card__add-btn" disabled>Add To Cart</button>' +
      '</div>';
  } else if (sizeIdx === -1) {
    var seenC = {};
    var optsC = "";
    variants.forEach(function(v) {
      var val = snzOptionValue(v, colorIdx);
      if (v.available && val && !seenC[val]) { seenC[val] = true; optsC += '<option value="' + val.replace(/\"/g, "&quot;") + '">' + val + '</option>'; }
    });
    controlsHTML = '<div class="cart-rec-card__controls">' +
      '<select class="cart-rec-card__select" data-role="color"><option value="">Pick a ' + optionDefs[colorIdx].name + '</option>' + optsC + '</select>' + spacerHTML +
      '<button type="button" class="btn cart-rec-card__add-btn" disabled>Add To Cart</button>' +
      '</div>';
  } else {
    var seenCol = {};
    var optsCol = "";
    variants.forEach(function(v) {
      var val = snzOptionValue(v, colorIdx);
      if (v.available && val && !seenCol[val]) { seenCol[val] = true; optsCol += '<option value="' + val.replace(/\"/g, "&quot;") + '">' + val + '</option>'; }
    });
    controlsHTML = '<div class="cart-rec-card__controls">' +
      '<select class="cart-rec-card__select" data-role="color"><option value="">Pick a ' + optionDefs[colorIdx].name + '</option>' + optsCol + '</select>' +
      '<select class="cart-rec-card__select" data-role="size" disabled><option value="">Pick a ' + optionDefs[sizeIdx].name + '</option></select>' +
      '<button type="button" class="btn cart-rec-card__add-btn" disabled>Add To Cart</button>' +
      '</div>';
  }

  return '<div class="cart-rec-card" data-handle="' + product.handle + '" data-color-idx="' + colorIdx + '" data-size-idx="' + sizeIdx + '">' +
    '<a href="' + product.url + '" class="cart-rec-card__image-link"><span class="cart-rec-card__image"><img src="' + mainImg + '" alt="' + safeTitle + '" loading="lazy"></span></a>' +
    '<a href="' + product.url + '" class="cart-rec-card__title">' + safeTitle + '</a>' +
    '<span class="cart-rec-card__price">' + snzFormatMoney(product.price) + '</span>' +
    controlsHTML +
    '</div>';
}

function snzFetchProductsByHandles(handles) {
  return Promise.all(handles.map(function(h) {
    return fetch("/products/" + h + ".js").then(function(r) {
      return r.ok ? r.json() : null;
    }).catch(function() { return null; });
  })).then(function(results) { return results.filter(Boolean); });
}

var loadCartRecommendationsIntoSection = function() {
  var cartRecSection = document.querySelector(".cart-recommendations");
  if (cartRecSection === null) { return; }
  var requestUrl = cartRecSection.dataset.url + "&cb=" + Date.now();
  var excludeHandles = (cartRecSection.dataset.cartHandles || "").split(",").filter(Boolean);

  fetch(requestUrl).then(function(r) { return r.text(); }).then(function(html) {
    var container = document.createElement("div");
    container.innerHTML = html;
    var fresh = container.querySelector(".cart-recommendations");
    var gridEl = fresh ? fresh.querySelector(".cart-recommendations-compact__grid") : null;
    var relatedHandles = gridEl ? (gridEl.getAttribute("data-related-handles") || "").split(",").filter(Boolean) : [];
    var titleEl = fresh ? fresh.querySelector(".cart-recommendations-compact__title") : null;

    var recentHandles = snzGetRecentlyViewedHandles().filter(function(h) {
      return excludeHandles.indexOf(h) === -1;
    });

    var orderedHandles = [];
    var seenHandle = {};
    recentHandles.concat(relatedHandles).forEach(function(h) {
      if (h && !seenHandle[h] && excludeHandles.indexOf(h) === -1) {
        seenHandle[h] = true;
        orderedHandles.push(h);
      }
    });
    orderedHandles = orderedHandles.slice(0, 4);

    if (orderedHandles.length === 0) { return; }

    snzFetchProductsByHandles(orderedHandles).then(function(products) {
      if (products.length === 0) { return; }
      var cardsHTML = products.map(function(p) {
        snzRecProductsByHandle[p.handle] = p;
        return snzBuildRecCardHTML(p);
      }).join("");
      var existingTitle = cartRecSection.querySelector(".cart-recommendations-compact__title");
      var titleHTML = titleEl ? titleEl.outerHTML : (existingTitle ? existingTitle.outerHTML : "");
      cartRecSection.innerHTML = titleHTML + '<div class="grid-flex cart-recommendations-compact__grid">' + cardsHTML + '</div>';
    });
  }).catch(function() {});
};

document.addEventListener("change", function(e) {
  if (!e.target.classList || !e.target.classList.contains("cart-rec-card__select")) { return; }
  var card = e.target.closest(".cart-rec-card");
  if (!card) { return; }
  var handle = card.getAttribute("data-handle");
  var product = snzRecProductsByHandle[handle];
  if (!product) { return; }

  var colorIdx = parseInt(card.getAttribute("data-color-idx"), 10);
  var sizeIdx = parseInt(card.getAttribute("data-size-idx"), 10);
  var colorSelect = card.querySelector('.cart-rec-card__select[data-role="color"]');
  var sizeSelect = card.querySelector('.cart-rec-card__select[data-role="size"]');
  var btn = card.querySelector(".cart-rec-card__add-btn");
  var colorVal = colorSelect ? colorSelect.value : null;

  if (sizeSelect && colorSelect && e.target === colorSelect) {
    var seen2 = {};
    var opts2 = "";
    product.variants.forEach(function(v) {
      var val = snzOptionValue(v, sizeIdx);
      if (v.available && snzOptionValue(v, colorIdx) === colorVal && val && !seen2[val]) {
        seen2[val] = true;
        opts2 += '<option value="' + val.replace(/\"/g, "&quot;") + '">' + val + '</option>';
      }
    });
    sizeSelect.innerHTML = '<option value="">Pick a ' + product.options[sizeIdx].name + '</option>' + opts2;
    sizeSelect.disabled = !colorVal;
    sizeSelect.value = "";
  }

  if (colorSelect && e.target === colorSelect) {
    var previewImg = card.querySelector(".cart-rec-card__image img");
    if (previewImg) {
      var preview = colorVal ? product.variants.filter(function(v) { return snzOptionValue(v, colorIdx) === colorVal && v.featured_image && v.featured_image.src; })[0] : null;
      previewImg.src = preview ? snzImageUrl(preview.featured_image.src) : snzImageUrl(product.featured_image);
    }
  }

  var sizeVal = sizeSelect ? sizeSelect.value : null;
  var match = null;

  if (colorSelect && sizeSelect) {
    if (colorVal && sizeVal) {
      match = product.variants.filter(function(v) { return snzOptionValue(v, colorIdx) === colorVal && snzOptionValue(v, sizeIdx) === sizeVal && v.available; })[0];
    }
  } else if (colorSelect && !sizeSelect) {
    if (colorVal) {
      match = product.variants.filter(function(v) { return snzOptionValue(v, colorIdx) === colorVal && v.available; })[0];
    }
  } else if (sizeSelect && !colorSelect) {
    if (sizeVal) {
      match = product.variants.filter(function(v) { return snzOptionValue(v, sizeIdx) === sizeVal && v.available; })[0];
    }
  }

  if (match) {
    btn.disabled = false;
    btn.setAttribute("data-variant-id", match.id);
    if (match.featured_image && match.featured_image.src) {
      var img = card.querySelector(".cart-rec-card__image img");
      if (img) { img.src = snzImageUrl(match.featured_image.src); }
    }
  } else {
    btn.disabled = true;
    btn.removeAttribute("data-variant-id");
  }
});

document.addEventListener("click", function(e) {
  var btn = e.target.closest ? e.target.closest(".cart-rec-card__add-btn") : null;
  if (!btn) { return; }
  var variantId = btn.getAttribute("data-variant-id");
  if (!variantId) { return; }

  // Nov 2026: tag add-to-cart requests coming from this widget with a hidden line-item
  // property ("_source"), and fire a Klaviyo custom event, so these adds are attributable
  // in Shopify orders and in Klaviyo — separate from the generic "Added to Cart" event
  // Klaviyo's Shopify integration already tracks for every add-to-cart. Underscore-prefixed
  // properties are hidden from the customer-facing cart/order confirmation.
  var card = btn.closest(".cart-rec-card");
  var handle = card ? card.getAttribute("data-handle") : null;
  var product = handle ? snzRecProductsByHandle[handle] : null;
  var variant = product ? (product.variants || []).filter(function(v) { return String(v.id) === String(variantId); })[0] : null;

  btn.disabled = true;
  var originalText = btn.textContent;
  btn.textContent = "Adding...";
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { "_source": "cart_recommendations" }
    })
  }).then(function(res) {
    if (res.ok) {
      try {
        if (window.klaviyo && typeof window.klaviyo.track === "function" && product) {
          window.klaviyo.track("Added Item From Cart Recommendations", {
            ProductName: product.title,
            ProductID: product.id,
            VariantID: variantId,
            VariantTitle: variant ? variant.title : null,
            Price: (variant ? variant.price : product.price) / 100,
            ProductURL: window.location.origin + product.url,
            ImageURL: snzImageUrl(product.featured_image)
          });
        }
      } catch (err) {}
      window.location.reload();
    } else {
      btn.disabled = false;
      btn.textContent = originalText;
      alert("Sorry, that item couldn't be added. Please try again.");
    }
  }).catch(function() {
    btn.disabled = false;
    btn.textContent = originalText;
  });
});

document.addEventListener("DOMContentLoaded", function(event) {
  loadCartRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
